<template>
  <footer class="golomt-footer">
    <div class="container pd-t-50 pd-b-30">
      <div class="row">
        <div v-if="$store.state.app.activeGroup.id == 9358" class="col-md-12 text-center">
          <div v-if="homeSettingFooterName !== '' || homeSettingFooterMobile !== '' || homeSettingFooterEmail !== ''" class="text-white" 
          style="font-weight: 600; border-bottom: 1px solid #FFFFFF; padding-bottom: 10px; max-width: 300px; margin: 0 auto;">
            Холбогдох ажилтны мэдээлэл
          </div>
          <div class="d-flex justify-content-center mg-t-5">
            <div class="nav-item" v-if="homeSettingFooterName !== ''">
              <a class="nav-link text-white">Нэр : {{homeSettingFooterName}}</a>
            </div>
            <div class="nav-item" v-if="homeSettingFooterMobile !== ''">
              <a :href="`tel:${homeSettingFooterMobile}`" class="nav-link text-white">Утас : {{ homeSettingFooterMobile }}</a>
            </div>
            <div class="nav-item" v-if="homeSettingFooterEmail !== ''">
              <a :href="`mailto:${homeSettingFooterEmail}`" class="nav-link text-white">И-мэйл : {{ homeSettingFooterEmail }}</a>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-center" v-else>
          <a
            v-if="
              $store.state.app.activeGroup.logoFooter != undefined &&
                $store.state.app.activeGroup.logoFooter != ''
            "
          >
            <img
              :src="$store.state.app.activeGroup.logoFooter"
              alt="footer_logo"
              class="img-fluid"
            />
          </a>
          <div class="d-flex justify-content-center mg-t-30">
            <div class="nav-item">
              <router-link
                :to="{
                  name: $store.state.app.activeGroup.publicPage.route,
                  params: { id: $store.state.app.homePageId, cid: 0 }
                }"
                class="nav-link text-white"
              >
                Нүүр
              </router-link>
            </div>
            <div class="nav-item">
              <a class="nav-link text-white">Хамтарч ажиллах</a>
            </div>
            <div class="nav-item"><a class="nav-link text-white">FAQ</a></div>
          </div>
          <template v-if="$store.state.app.activeGroup.id == 9247">
            <div class="d-flex justify-content-center mg-t-30">
              <div class="nav-item mg-r-20">
                <a
                  target="_blank"
                  href="https://www.facebook.com/%D0%9C%D0%BE%D0%BD%D0%B3%D0%BE%D0%BB%D1%8B%D0%BD-%D2%AE%D0%BD%D0%B4%D1%8D%D1%81%D0%BD%D0%B8%D0%B9-%D0%9C%D0%B0%D0%BB-%D0%AD%D0%BC%D0%BD%D1%8D%D0%BB%D0%B3%D0%B8%D0%B9%D0%BD-%D0%A5%D0%BE%D0%BB%D0%B1%D0%BE%D0%BE-799240646933474"
                  ><feather type="facebook" class="text-white"></feather
                ></a>
              </div>
              <!-- <div class="nav-item mg-r-20"><feather type="linkedin" class="text-white"></feather></div> -->
              <div class="nav-item">
                <a target="_blank" href="https://www.instagram.com/batsukh833/"
                  ><feather type="instagram" class="text-white"></feather
                ></a>
              </div>
              <!-- <div class="nav-item"><a target="_blank" href="https://www.instagram.com/batsukh833/"><feather type="twitter" class="text-white"></feather></a></div> -->
            </div>
          </template>
          <div v-else class="d-flex justify-content-center mg-t-30">
            <div class="nav-item mg-r-20">
              <feather type="facebook" class="text-white"></feather>
            </div>
            <div class="nav-item mg-r-20">
              <feather type="linkedin" class="text-white"></feather>
            </div>
            <div class="nav-item">
              <feather type="instagram" class="text-white"></feather>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="copyright">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <span>
              © <span>{{ $store.state.app.activeGroup.name | stripHtml }}</span
              >, бүх эрх хуулиар хамгаалагдсан.
            </span>
            <a href="https://www.gosmart.mn" class="text-white" target="_blank">
              <img :src="`${myResBaseUrl}/media/favicon/fav.png`" />
              Хөгжүүлсэн ГөүCмарт ТМ ХХК</a
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { request } from "@/api/all";

export default {
  data(){
    return{
      myResBaseUrl: "https://res.gosmart.mn/",
      homeSettingFooterName: "",
      homeSettingFooterMobile: "",
      homeSettingFooterEmail: "",
    }
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }

    request({
      api: { method: "GET", url: "User/GetHomeSettingsByKey" },
      params: { key: this.$store.state.app.activeGroup.key },
      store: this.$store,
    }).then((res) => {
      if (res != false) {
        let tempFooterName = res.settings.filter((x) => x.key == "homeSetting_FooterName");
        let tempFooterMobile = res.settings.filter((x) => x.key == "homeSetting_FooterMobile");
        let tempFooterEmail = res.settings.filter((x) => x.key == "homeSetting_FooterMail");
        
        if (tempFooterName.length > 0 && tempFooterName[0].value !== "") {
          this.homeSettingFooterName = tempFooterName[0].value;
        }
        if (tempFooterMobile.length > 0 && tempFooterMobile[0].value !== "") {
          this.homeSettingFooterMobile = tempFooterMobile[0].value;
        }
        if (tempFooterEmail.length > 0 && tempFooterEmail[0].value !== "") {
          this.homeSettingFooterEmail = tempFooterEmail[0].value;
        }
      }
    });
  },
};
</script>

<style></style>
